import toast from 'react-hot-toast'

export const notifySuccess = (message = '') => toast.success(message, {duration: 5000})

export const notifyError = (message = '') => toast.error(message, {duration: 5000})

export const loader = (message = 'Loading') => toast.loading(message, {
    position: "top-center"
  })